export default {
  title: 'Szczegóły podatkowe',
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    success: 'Informacje zostały pomyślnie zapisane.',
  },
};
